import * as Sentry from '@sentry/react';
import { Component } from 'react';

interface ErrorBoundaryProps {
  fallbackComponent: React.ComponentType<{ error: unknown }>;
  children?: React.ReactNode;
}

/**
 * Error boundary to catch errors during rendering
 *
 * Based on https://reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps> {
  state: { error: unknown } = { error: null };

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, { extra: { errorInfo } });
  }

  render() {
    const { error } = this.state;

    if (error) {
      const { fallbackComponent: Component } = this.props;

      return <Component error={error} />;
    }

    return this.props.children;
  }
}
